import type { IconProps } from "@/types/icon";

const ChevronUp = ({ color = "black", className }: IconProps) => (
  <svg
    width="13"
    height="14"
    viewBox="0 0 13 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M9.97737 8.51127L6.95487 5.48877L3.93237 8.51127"
      stroke={color}
      strokeWidth="1.209"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ChevronUp;
